import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import ToolTip from '@/components/ToolTip/ToolTip';
import styles from './EllipsisWithTooltip.module.scss';

export default function EllipsisWithTooltip({
  text,
  lines = 2,
  tooltipTitle,
  className = '',
  textClassName = '',
}) {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const measure = () => {
    const el = textRef.current;
    if (!el) return;

    // Consider truncated only when the clamped element has vertical overflow
    setIsTruncated(el.scrollHeight > el.clientHeight + 1);
  };

  const scheduleMeasure = () => {
    measure();
    requestAnimationFrame(() => measure());
    setTimeout(() => measure(), 0);
    setTimeout(() => measure(), 50);
  };

  useLayoutEffect(() => {
    scheduleMeasure();
  }, [text, lines]);

  useEffect(() => {
    const el = textRef.current;
    if (!el) return undefined;

    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(() => scheduleMeasure());
      ro.observe(el);
      return () => ro.disconnect();
    }

    window.addEventListener('resize', scheduleMeasure);
    return () => window.removeEventListener('resize', scheduleMeasure);
  }, [text, lines]);

  const content = (
    <span
      ref={textRef}
      className={[styles.text, textClassName].filter(Boolean).join(' ')}
      style={{
        WebkitLineClamp: lines,
        lineClamp: lines,
      }}
    >
      {text}
    </span>
  );

  return (
    <ToolTip
      title={isTruncated ? tooltipTitle ?? text : null}
      className={className}
      onMouseEnter={scheduleMeasure}
    >
      {content}
    </ToolTip>
  );
}
